// extracted by mini-css-extract-plugin
export default {"box":"TopRowPctQtySwitch_box__VBXqt","selected":"TopRowPctQtySwitch_selected__sYrbw","notSelected":"TopRowPctQtySwitch_notSelected__GE8zR"};